@let r = report();

@if (r.blockers.length > 0) {
  <div class="cir-blockers" role="alert" data-testid="ci-report-blockers">
    <div class="cir-blockers__title">
      <mat-icon aria-hidden="true">block</mat-icon>
      <span class="cir-blockers__title-text">{{ 'classicImport.report.blockedTitle' | translate }}</span>
    </div>
    <ul class="cir-blockers__list">
      @for (blocker of r.blockers; track $index) {
        <li>
          @if (blocker.name) {
            <strong>{{ blocker.name }}:</strong>
          }
          {{ blocker.text }}
        </li>
      }
    </ul>
  </div>
}

@if (!blockersOnly()) {
  <div class="cir-tiles">
    @for (tile of tiles(); track tile.type) {
      <div class="cir-tile" data-testid="ci-report-tile">
        <div class="cir-tile__title">{{ 'classicImport.report.counts.' + tile.type | translate }}</div>
        <div class="cir-tile__value" data-testid="ci-tile-created">
          <strong>{{ tile.count.created }}</strong>
          {{ 'classicImport.report.created' | translate }}
        </div>
        <div class="cir-tile__line" data-testid="ci-tile-replaced">
          {{ tile.count.replaced }} {{ 'classicImport.report.replaced' | translate }}
        </div>
        <div class="cir-tile__line" data-testid="ci-tile-unchanged">
          {{ tile.count.unchanged }} {{ 'classicImport.report.unchanged' | translate }}
        </div>
        @if (tile.count.skipped > 0) {
          <div class="cir-tile__line" data-testid="ci-tile-skipped">
            {{ tile.count.skipped }} {{ 'classicImport.report.skipped' | translate }}
          </div>
        }
      </div>
    }
  </div>

  @if (r.summaries.length > 0) {
    <ul class="cir-summaries">
      @for (summary of r.summaries; track $index) {
        <li data-testid="ci-report-summary">
          {{
            (summary.repository ? 'classicImport.report.summary' : 'classicImport.report.summaryUnnamed')
              | translate: summary
          }}
        </li>
      }
    </ul>
  }

  <div class="cir-messages">
    <div class="cir-messages__head">
      <h3 class="cir-messages__title">{{ 'classicImport.report.messagesTitle' | translate }}</h3>
      <button type="button" class="cir-download" data-testid="ci-report-download" (click)="download.emit()">
        <mat-icon aria-hidden="true">download</mat-icon>
        {{ 'classicImport.report.download' | translate }}
      </button>
    </div>

    @if (r.messages.length === 0) {
      <p class="cir-empty" data-testid="ci-report-empty">{{ 'classicImport.report.noMessages' | translate }}</p>
    } @else {
      <div class="cir-filters">
        <app-segmented-filter-control
          density="compact"
          [items]="levelItems()"
          [value]="level()"
          [ariaLabel]="'classicImport.report.filterLevel' | translate"
          (valueChange)="onLevel($event)"
        />
        <app-segmented-filter-control
          density="compact"
          [items]="groupItems()"
          [value]="group()"
          [ariaLabel]="'classicImport.report.filterGroup' | translate"
          (valueChange)="onGroup($event)"
        />
      </div>

      @for (g of groups(); track g.group) {
        <section class="cir-group">
          <button
            type="button"
            class="cir-group__toggle"
            data-testid="ci-report-group-toggle"
            [attr.aria-expanded]="isExpanded(g.group)"
            (click)="toggle(g.group)"
          >
            <mat-icon aria-hidden="true">{{ isExpanded(g.group) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <span class="cir-group__label">{{ 'classicImport.report.groups.' + g.group | translate }}</span>
            <span class="cir-group__count">{{ g.messages.length }}</span>
          </button>
          @if (isExpanded(g.group)) {
            <ul class="cir-group__list">
              @for (m of g.messages; track $index) {
                <li class="cir-msg" data-testid="ci-report-message">
                  <span class="cir-msg__level" [class]="'cir-msg__level--' + m.level">
                    {{ 'classicImport.report.levels.' + m.level | translate }}
                  </span>
                  <span class="cir-msg__element">{{ m.name ?? m.element }}</span>
                  <span class="cir-msg__origin" data-testid="ci-report-origin">{{ origin(m) }}</span>
                  <span class="cir-msg__text">{{ m.text }}</span>
                </li>
              }
            </ul>
          }
        </section>
      } @empty {
        <p class="cir-empty" data-testid="ci-report-nomatch">{{ 'classicImport.report.noMatch' | translate }}</p>
      }
    }
  </div>
}
